export default {
  orgName: '组织名称',
  orgType: '组织类型',
  area: '地区',
  maintainerSum: '运维人员数量',
  subOrgSum: '子机构数量',
  lastTurnOnTime: '最近一次终端开机时间',
  lastLoginTime: '最近一次web登录时间',
  lastMemberAddTime: '最近一次web成员加入时间',
  lastMaintainedTime: '最近一次被代运维时间',
  operate: '操作',
  seeDtl: '查看详情',
  seeWhiteList: '查看白名单详情',
  terminalOnlineTrend: '终端在线趋势',
  terminalPurchaseInfo: '终端部署信息',
  terminalDeployInfo: '终端部署偏好',
  operateRank: '管理员的行为排行版(web+小程序)',
  firstLoginBehavior: '查看web第一次登录后的操作',
  firstLoginBehaviorTitle: 'web第一次登录后的操作',
  purchaseSum: '部署情况',
  repurchaseSum: '追加部署情况',
  netSituation: '网络情况',
  terminalSetting: '终端配置',
  deskPattern: '桌面类型：',
  terminalMode: '终端模式：',
  loginMode: '终端登录模式：',
  searchKeyword: '组织名称/地区',
  localDiskSituation: '本地盘使用情况：',
  behaviorDtl: '【{orgName}】组织下的【{behaviorName}】行为详情',
  terminalBehaviorDtl: '【{orgName}】组织下的【{behaviorName}】行为详情',
  behaviorAllDtl: '【{orgName}】组织下的所有的管理员的行为(web+小程序)',
  terminalBehaviorAllDtl: '【{orgName}】组织下的所有终端使用者的行为',
  behaviorTerminalDtl: '【{terminalName}】终端下的行为详情',
  industry: '行业',
  moreHandle: '更多操作',
  termianlSum: '终端数量',
  createTime: '组织创建时间',
  orgId: '组织ID',
  activeStatus: '组织活跃情况',
  seeAllBehavior: '查看全部的管理员的行为(web+小程序)',
  outIpSpread: '终端出口IP分布',
  orgRelaction: '组织的售后代运维关系',
  purchaseRelation: '终端-锐捷发货信息',
  terminalBehaviorRank: '终端使用者的行为排行版',
  seeAllTerminalBehavior: '查看全部终端使用者的行为',
  orgAdminNum: '管理员数量',
  terminalOnline: '终端在线',
  deskOnline: '桌面在线',
  teminalOffline: '终端离线',
  upgrading: '升级中',
  remoteAutoAgreeTip: '用户开启协助',
  shareStateTip: '终端已开启部署配置分享',
  unDeployTip: '终端未部署',
  remoteAssisted: '用户开启协助​',
  sharedDeploy: '已开启部署配置分享',
  unDeploy: '未部署'
}
